import React, { useState } from "react";
import { Route, Switch, useHistory, useParams } from "react-router-dom";
import { useQueryString } from "../../../Hooks/useQueryString";
import { LoginOnboardingEmailInput } from "./LoginOnboardingEmailInput/LoginOnboardingEmailInput";
import "./LoginOnboardingForm.css";
import { LoginOnboardingLoginForm } from "./LoginOnboardingLoginForm/LoginOnboardingLoginForm";
import { LoginOnboardingOnboardingForm } from "./LoginOnboardingOnboardingForm/LoginOnboardingOnboardingForm";

export const LoginOnboardingForm = () => {
  /** @type {*} */
  const params = useParams();
  const queryParams = useQueryString();

  // We get the email from the url (both params and query params to be sure)
  const defaultEmail = params.email || queryParams.get("email") || "";
  const defaultRedirect = queryParams.get("redirect");

  const [email, setEmail] = useState(defaultEmail);

  const history = useHistory();

  // Event handlers
  function onUserShouldBeLoggedIn(email) {
    setEmail(email);

    // Construct the url params to relay to next route
    const queryParams = new URLSearchParams();

    // Set the email param
    queryParams.set("email", email);

    // Set the redirect param if provided
    if (defaultRedirect) {
      queryParams.set("redirect", defaultRedirect);
    }

    // Go to authenticate step
    history.push(`/login/authenticate?${queryParams}`);
  }

  function onUserShouldBeOnboarded(email) {
    setEmail(email);

    // Construct the url params to relay to next route
    const queryParams = new URLSearchParams();

    // Set the email param
    queryParams.set("email", email);

    // Set the redirect param if provided
    if (defaultRedirect) {
      queryParams.set("redirect", defaultRedirect);
    }

    // Go to onboarding step
    history.push(`/login/eflow-onboarding?${queryParams}`);
  }

  return (
    <div className="LoginOnboardingForm">
      <Switch>
        <Route
          path="/login/authenticate"
          exact
          render={() => (
            <LoginOnboardingLoginForm
              defaultEmail={email}
              defaultRedirect={defaultRedirect}
            />
          )}
        />
        <Route
          path="/login/eflow-onboarding"
          exact
          render={() => (
            <LoginOnboardingOnboardingForm
              defaultEmail={email}
              defaultRedirect={defaultRedirect}
            />
          )}
        />
        <Route
          render={() => (
            <LoginOnboardingEmailInput
              defaultEmail={email}
              onUserShouldBeLoggedIn={onUserShouldBeLoggedIn}
              onUserShouldBeOnboarded={onUserShouldBeOnboarded}
            />
          )}
        />
      </Switch>
    </div>
  );
};
